import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center w-full ml-3" }

import { useRouter } from "vue-router";
//import Lucide from "../../base-components/Lucide";
import { FormattedMenu, linkTo } from "@/components/MainMenu/main-menu";
import {checkTypeOfIcon, substractNameOfIcon} from "@wpmss/ts-icons-helper"

interface MenuProps {
  menu: FormattedMenu;
  formattedMenuState: [
    (FormattedMenu | "divider")[],
    (computedFormattedMenu: Array<FormattedMenu | "divider">) => void
  ];
  level: "first" | "second" | "third" | "last";
  setActiveMobileMenu: (active: boolean) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuLink',
  props: {
    menu: null,
    formattedMenuState: null,
    level: null,
    setActiveMobileMenu: null
  },
  setup(__props: any) {

const props = __props as {
  menu: FormattedMenu;
  formattedMenuState: [
    (FormattedMenu | "divider")[],
    (computedFormattedMenu: Array<FormattedMenu | "divider">) => void
  ];
  level: "first" | "second" | "third" | "last";
  setActiveMobileMenu: (active: boolean) => void;
}

const router = useRouter();

// eslint-disable-next-line
const [formattedMenu, setFormattedMenu] = props.formattedMenuState;
function goToApp(menu:any, router:any, event: Event) {
  if(menu.subMenu == undefined  || menu.subMenu.length == 0) {
  props.setActiveMobileMenu(false);
  }
  linkTo(menu, router, event);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Lucide = _resolveComponent("Lucide")!

  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([
      'h-[50px] flex items-center text-white',
      props.level == 'first' && 'px-6',
      props.level != 'first' && 'px-4',
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goToApp(props.menu, _unref(router), $event)))
  }, [
    _createElementVNode("div", null, [
      (props.menu.menu_icon != 'no icon')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'FontAwesome')
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "h-7",
                  icon: _unref(substractNameOfIcon)(props.menu.menu_icon)
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'Lucide')
              ? (_openBlock(), _createBlock(_component_Lucide, {
                  key: 1,
                  icon: props.menu.menu_icon,
                  class: ""
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'HeroIcon')
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(props.menu.menu_icon), {
                  key: 2,
                  class: "w-9"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t(props.menu.title)) + " ", 1),
      (props.menu.subMenu && props.menu.subMenu.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          'transition ease-in duration-100 ml-auto',
          props.menu.activeDropdown && 'transform rotate-180',
        ])
          }, [
            _createVNode(_component_Lucide, {
              icon: "ChevronDown",
              class: "w-5 h-5"
            })
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})